export const DEFAULT_FILTERS = {
  name: {
    title: 'Quote name',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'editor-text-mono'
  }
};
